import React from 'react'
import {VIEW_TYPES} from "../../utils/constants";

export default class ViewTypeDropdown extends React.Component{
	static defaultProps = {
		currentViewType: VIEW_TYPES.MOST_RECENT,
		changeViewType: () => console.log('ViewTypeDropdown component needs a changeViewType function!')
	}
	
	constructor(props) {
		super(props)
		
		this.state = {
			currentViewType: this.props.currentViewType
		}
	}
	
	handleInputChange(event){
		const newViewType = event.target.value
		
		this.setState({
			currentViewType: newViewType
		}, () => (
			this.props.changeViewType(newViewType)
		))
	}
	
	render(){
		return(
			<div className={'select-container'}>
				<p>Change View:</p>
				<select value={this.state.currentViewType} onChange={this.handleInputChange.bind(this)}>
					<option value={VIEW_TYPES.MOST_RECENT}>Most Recent</option>
					<option value={VIEW_TYPES.MONTHLY}>Monthly</option>
				</select>
			</div>
		)
	}
}